export enum GuestValidity {
  Undefined = 'Undefined',
  OneDay = 'OneDay',
  Permanent = 'Permanent',
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  DateRange = 'DateRange',
  OneTime = 'OneTime',
}

export enum ServerGuestValidity {
  Undefined = 'Undefined',
  OneDay = 'OneDay',
  Permanent = 'Permanent',
  DateRange = 'DateRange',
  OneTime = 'OneTime',
}
